import * as R from 'ramda';
import { useQuery } from '@cd/react-query';
import { postJSONPS } from '@cd/utils';
import { either } from '@cd/utils';

export default function useSideTabs(dispatch, { routeName }) {
	const url = `/get/widget/tabs/${routeName}`;

	return useQuery(
		['sideTabs', routeName],
		() =>
			postJSONPS('GET', url).then(
				either(e => {
					dispatch({ type: 'post error', e });
					throw new Error(e);
				}, R.identity)
			),
		{
			// routeName is null until usePathMatch has run; skip the
			// /get/widget/tabs/undefined round trip.
			enabled: !!routeName,
			// Keep the old tabs while the next route loads so isLoading does
			// not flip and PaymentApp does not unmount the current page
			// (a remount of PayInvoice created a second PaymentIntent).
			keepPreviousData: true
		}
	);
}
